import { render, staticRenderFns } from "./V2DashboardBrandsList.vue?vue&type=template&id=15341cdb&scoped=true&"
import script from "./V2DashboardBrandsList.vue?vue&type=script&lang=js&"
export * from "./V2DashboardBrandsList.vue?vue&type=script&lang=js&"
import style0 from "./V2DashboardBrandsList.vue?vue&type=style&index=0&id=15341cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15341cdb",
  null
  
)

export default component.exports